import { combineUrlParams } from 'src/common';
import { AREA_API, NOTIFICATION_API } from 'src/helpers/api';
import axiosIns from 'src/helpers/request';

// gọi API khu vực
export async function fetchNotification (params = {}) {
  const response = await axiosIns.get(combineUrlParams(NOTIFICATION_API.SEARCH, { ...params, limit:10, page:1 }))
  return response.data?.data
}